import { getCommonTrackingParams } from 'Common/logging/tokens';
import { getGxContextualInfo, getDeepLinkingParams } from '../utils';
import { getRelativeParameterizedBookingUrl } from '../../utils/getRelativeParameterizedBookingUrl';
import {
  getAltProviders,
  getCareTeamProviders
} from '../../behaviors/providers/services';
import { getPatientRegForm } from '../../behaviors/forms';
import { MODULES, isModuleEnabled } from 'Common/config';
import { getProviderProfilePath } from 'Common/urls/provider';
import axios from 'axios';

/**
 * Function that returns the default config for Direct Book.
 * @param {Object} props - The config properties
 * @param {string} props.customerCode - represents a customer
 * @param {Object} props.location - the react-router location object
 * @returns the default config
 */
export const getDefaultConfig = ({
  customerCode,
  location,
  config,
  searchSDK
}) => {
  const searchClient = searchSDK.current;
  const createAvailabilityUrl = (provider) => {
    return getRelativeParameterizedBookingUrl({
      provider,
      config,
      location
    });
  };
  const createProviderUrl = isModuleEnabled(config, MODULES.PROFILE)
    ? getProviderProfilePath
    : () => undefined;
  const getProviderById = async (id) => {
    const params = {
      id,
      context: config.index || customerCode,
      ...getCommonTrackingParams(),
      provider_fields: ['-clinical_keywords'].join(',')
    };
    const res = await searchClient.getProviderById(params);

    // TODO: no longer wrap `res` in `data`: https://kyruus.jira.com/browse/KENG-32234
    return {
      data: res
    };
  };

  const createAppointmentWaitList = async (requestBody) => {
    return await axios.post(
      `/api/scheduling/${encodeURIComponent(customerCode)}/waitlist/create`,
      requestBody
    );
  };

  const getCareTeams = (provider, queryParams = {}) =>
    getCareTeamProviders({
      provider,
      customerCode,
      config,
      searchSDK,
      queryParams: {
        per_page: 2,
        page: 1,
        location_fields: [
          '-ALL',
          'id',
          'name',
          'street1',
          'street2',
          'city',
          'suite',
          'state',
          'zip'
        ].join(','),
        provider_fields: [
          '-ALL',
          'id',
          'name',
          'image_url',
          'specialties',
          'book_online_url'
        ].join(','),
        ...queryParams
      }
    });

  const getSimilarProviders = (provider, locations, queryParams) =>
    getAltProviders({
      provider,
      locations,
      customerCode,
      config,
      searchSDK,
      queryParams: {
        per_page: 2,
        page: 1,
        location_fields: [
          '-ALL',
          'id',
          'name',
          'street1',
          'street2',
          'city',
          'suite',
          'state',
          'zip'
        ].join(','),
        provider_fields: [
          '-ALL',
          'id',
          'name',
          'image_url',
          'specialties',
          'book_online_url'
        ].join(','),
        ...queryParams
      }
    });

  return {
    customerCode,
    deepLinkingParams: getDeepLinkingParams(location.search),
    showApptSummary: true,
    gxContextualInfo: getGxContextualInfo(location),
    services: {
      createAvailabilityUrl,
      createProviderUrl,
      getProviderById,
      getAltProviders: getSimilarProviders,
      getPatientRegForm: getPatientRegForm,
      createAppointmentWaitList,
      getCareTeamsProviders: getCareTeams
    }
  };
};
